import React from 'react'
import {
  Switch,
  Route,
  Link
} from "react-router-dom"

import { Layout, Menu } from 'antd'
// import {
//   // EditOutlined,
//   // DesktopOutlined,
//   // FileOutlined,
//   // TeamOutlined,
//   // UserOutlined,
//   // PieChartOutlined,
//   // BankOutlined,
//   // DollarOutlined
// } from '@ant-design/icons'
import cx from "classnames"

import { useTheme } from '../contexts/ThemeContext'
import logo from "../assets/images/logo-text-w.png"
import logoIcon from "../assets/images/logo-icon-w.png"

import HeaderOne from './HeaderOne'
// import Page404 from '../page/404'
import routes from "../routes"
import { useAuth } from "../contexts/AuthContext"
// import SiderLayout from './Sider'
// import FooterOne from './FooterOne'

const { Sider } = Layout

// const { SubMenu } = Menu

const AdminLayout = () => {
  console.log("AdminLayout")
  const { user } = useAuth()
  const { pathname, siderFixed, collapsed, fullCollapsed, toggleCollapse, keysFromPath } = useTheme()

  return (
    <Layout style={{ minHeight: '100vh' }} className={cx({ "ant-sider-fixed": siderFixed })}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapse}
        breakpoint="lg"
        collapsedWidth={fullCollapsed ? 0 : 50}
        onBreakpoint={broken => {
          console.log(broken)
        }}
      >
        <div className="logo"><img src={logo} alt="logo" /></div>
        <div className="logo collapsed"><img src={logoIcon} alt="l" /></div>
        <Menu
          theme="dark"
          mode="inline"
          // defaultSelectedKeys={['']}
          selectedKeys={[pathname]}
        >
          {routes.map(route => (route.menu && route.roles.find(role => role === user.role) &&
            <Menu.Item key={keysFromPath(route.path)} icon={route.icon && <route.icon />}>
              <Link to={route.path}>{route.label}</Link>
            </Menu.Item>
          ))}
          {/* <Menu.Item key="" icon={<PieChartOutlined />}>
            <Link to="/">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="transactions" icon={<DollarOutlined />}>
            <Link to="/transactions">Transactions</Link>
          </Menu.Item>
          <Menu.Item key="banks" icon={<BankOutlined />}>
            <Link to="/banks">Banks</Link>
          </Menu.Item> */}
          {/* <Menu.Item key="posts" icon={<DesktopOutlined />}>
            Post
          </Menu.Item>
          <SubMenu key="post-sub" icon={<EditOutlined />} title="Posts">
            <Menu.Item key="post-all">
              <Link to="/posts">All Posts</Link>
            </Menu.Item>
            <Menu.Item key="post-add">
              <Link to="/posts/add">Add New Post</Link>
            </Menu.Item>
          </SubMenu>
          <Menu.Item key="20" icon={<DesktopOutlined />}>
            Option 2
          </Menu.Item>
          <SubMenu key="sub1" icon={<UserOutlined />} title="Users">
            <Menu.Item key="34">
              <Link to="/users">All Users</Link>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="sub2" icon={<TeamOutlined />} title="Team">
            <Menu.Item key="6">Team 1</Menu.Item>
            <Menu.Item key="8">Team 2</Menu.Item>
          </SubMenu>
          <Menu.Item key="9" icon={<FileOutlined />}>
            <Link to="/files">Files</Link>
          </Menu.Item> */}
        </Menu>
      </Sider>
      <Layout className="main-layout">
        {/* <Header className="site-layout-sub-header-background" style={{ padding: 0 }} /> */}
        <HeaderOne />
        <Layout className="site-layout">
          <Switch>
            {routes.map(route => (route.roles.find(role => role === user.role) &&
              <Route key={route.path} exact path={route.path} render={props => (<route.component {...props} />)} />
            ))}
            {/* <Route path="*" component={Page404} /> */}
            {/* <Route exact path="/" component={Dashboard} />
            <Route exact path="/banks" component={Banks} />
            <Route exact path="/banks/add" component={BanksAdd} />
            <Route exact path="/banks/edit/:id" component={BanksEdit} />
            <Route exact path="/transactions" component={Transactions} />
            <Route exact path="/transactions/add" component={TransactionsAdd} />
            <Route exact path="/transactions/edit/:id" component={TransactionsEdit} />
            <Route exact path="/users" component={User} />
            <Route exact path="/posts" component={Posts} />
            <Route exact path="/posts/add" component={PostsAdd} /> */}
          </Switch>
        </Layout>
        {/* <FooterOne /> */}
      </Layout>
    </Layout>
  )
}

export default React.memo(AdminLayout)